import useIsMobile from '@/hooks/use-is-mobile';
import dynamic from 'next/dynamic';

const FilterAside = dynamic(() => import('@/components/filter-section/filter-aside'), {
  ssr: false,
  loading: () => {
    return <div className='w-[269px] flex-none' />;
  },
});

const FilterAsideLazyLoad = props => {
  const isMobile = useIsMobile();

  return isMobile ? <div className='hidden w-[269px] flex-none lg_block'></div> : <FilterAside {...props} />;
};

export default FilterAsideLazyLoad;
